<template>
  <div class="ma-4">
    <SignaturePad
      :showSignaturePad="showSignaturePadClient"
      @close="showSignaturePadClient = false"
      @signatureData="signatureDataClient"
    />

    <SignaturePad
      :showSignaturePad="showSignaturePadGuardian"
      @close="showSignaturePadGuardian = false"
      @signatureData="signatureDataGuardian"
    />

    <ClientNav />
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <validation-observer ref="observer">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="4">
                    <v-menu
                      ref="menu6"
                      v-model="menu6"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Start date"
                          rules="required"
                        >
                          <v-text-field
                            v-model="newStartDate"
                            label="Start Date"
                            prepend-icon="mdi-calendar"
                            :readonly="readonly"
                            v-bind="attrs"
                            v-on="on"
                            clearable
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                      </template>
                      <v-date-picker
                        v-model="newStartDate"
                        no-title
                        scrollable
                        :readonly="readonly"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Review date"
                          rules="required"
                        >
                          <v-text-field
                            v-model="newReviewDate"
                            label="Review Date"
                            prepend-icon="mdi-calendar"
                            :readonly="readonly"
                            v-bind="attrs"
                            v-on="on"
                            clearable
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                      </template>
                      <v-date-picker
                        v-model="newReviewDate"
                        no-title
                        scrollable
                        :readonly="readonly"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :return-value.sync="date"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Date expires"
                          rules="required"
                        >
                          <v-text-field
                            v-model="newDateExpires"
                            label="Date Expires"
                            prepend-icon="mdi-calendar"
                            :readonly="readonly"
                            v-bind="attrs"
                            v-on="on"
                            clearable
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                      </template>
                      <v-date-picker
                        v-model="newDateExpires"
                        no-title
                        scrollable
                        :readonly="readonly"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Restriction</v-card-title>
                      <v-divider></v-divider>

                      <v-card-subtitle
                        >Specific and individualized assessed need. If
                        applicable, a way for other individuals to circumvent.
                      </v-card-subtitle>

                      <v-col cols="12">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Restriction"
                          rules="required"
                        >
                          <v-text-field
                            label="Enter Resctriction"
                            outlined
                            v-model="newRestriction"
                            :readonly="readonly"
                            :error-messages="errors"
                          ></v-text-field>
                        </validation-provider>
                      </v-col>

                      <v-col cols="12">
                        <v-file-input
                          v-model="newDocument"
                          class="pa-2"
                          label="Select documents to upload"
                          show-size
                          filled
                          multiple
                          prepend-icon="mdi-camera"
                          accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          @change="fileSelected"
                          :readonly="readonly"
                        >
                          <template #selection="{ text, index }">
                            <v-chip
                              small
                              label
                              close
                              color="primary"
                              @click:close="deleteChip(index)"
                            >
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        v-for="doc in newDocument"
                        :key="doc.awsLink"
                      >
                        <v-img
                          v-if="doc.ext !== 'pdf'"
                          max-height="80"
                          max-width="150"
                          :src="doc.awsLink"
                        ></v-img>
                        <template v-if="doc.ext == 'pdf'">
                          <LoadPDF :pdfFile="doc.awsLink" :pdfName="doc.name" />
                        </template>
                      </v-col>
                      <v-card-actions>
                        <v-btn class="btn-supporting-doc ma-2" small
                          >View Supporting Documentation
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Justification</v-card-title>
                      <v-divider></v-divider>
                      <v-card-subtitle
                        >A clear description of the condition that is directly
                        proportionate to the specific assessed need.
                      </v-card-subtitle>
                      <v-col cols="12">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Justification"
                          rules="required"
                        >
                          <v-textarea
                            label="Enter Justification"
                            outlined
                            v-model="newJustification"
                            :readonly="readonly"
                            :error-messages="errors"
                          ></v-textarea>
                        </validation-provider>
                      </v-col>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Previous Interventions</v-card-title>
                      <v-divider></v-divider>
                      <v-card-subtitle
                        >Less Intrusive methods used that did not work. Previous
                        positive interventions and supports tried.
                      </v-card-subtitle>
                      <v-col cols="12">
                        <validation-provider
                          v-slot="{ errors }"
                          name="Interventions"
                          rules="required"
                        >
                          <v-textarea
                            label="Enter Interventions"
                            outlined
                            v-model="newIntervention"
                            :readonly="readonly"
                            :error-messages="errors"
                          ></v-textarea>
                        </validation-provider>
                      </v-col>

                      <v-col cols="12">
                        <v-file-input
                          v-model="newDocument2"
                          class="pa-2"
                          label="Upload Previous Intervention Documentation"
                          show-size
                          filled
                          multiple
                          prepend-icon="mdi-camera"
                          accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          @change="selectedReviewFile"
                          :readonly="readonly"
                        >
                          <template #selection="{ text, index }">
                            <v-chip
                              small
                              label
                              close
                              color="primary"
                              @click:close="deleteChip2(index)"
                            >
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>

                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        v-for="doc in newDocument2"
                        :key="doc.awsLink"
                      >
                        <v-img
                          v-if="doc.ext !== 'pdf'"
                          max-height="80"
                          max-width="150"
                          :src="doc.awsLink"
                        ></v-img>
                        <template v-if="doc.ext === 'pdf'">
                          <LoadPDF :pdfFile="doc.awsLink" :pdfName="doc.name" />
                        </template>
                      </v-col>

                      <v-card-actions>
                        <v-btn small @click="!createHumanRights"
                          >View Previous Interventions
                        </v-btn>
                      </v-card-actions>

                      <v-col cols="12" v-if="!createHumanRights">
                        <v-textarea
                          label="Previous Interventions"
                          outlined
                          v-model="previousIntervention"
                          :readonly="readonly"
                        ></v-textarea>
                      </v-col>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Data Collection</v-card-title>
                      <v-divider></v-divider>
                      <v-card-subtitle
                        >Regular collection and review of data of measure
                        effectiveness.
                      </v-card-subtitle>
                      <v-card-actions>
                        <v-btn class="ma-2" small @click="goToReport()"
                          >View Data Collection
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Review</v-card-title>
                      <v-divider></v-divider>

                      <v-card-subtitle
                        >Establish time limits for period reviews to determine
                        if it is still necessary or can be terminated.
                      </v-card-subtitle>
                      <v-col cols="12">
                        <v-textarea
                          label="Enter Review Details Include Restoration and Fade Plan"
                          outlined
                          v-model="newReview"
                          :readonly="readonly"
                        ></v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-file-input
                          v-model="reviewDocument"
                          class="pa-2"
                          label="Upload Review Documents"
                          show-size
                          filled
                          multiple
                          prepend-icon="mdi-camera"
                          accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                          @change="fileSelected2"
                          :readonly="readonly"
                        >
                          <template #selection="{ text, index }">
                            <v-chip
                              small
                              label
                              close
                              color="primary"
                              @click:close="deleteReviewDocument(index)"
                            >
                              {{ text }}
                            </v-chip>
                          </template>
                        </v-file-input>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        v-for="doc in reviewDocument"
                        :key="doc.awsLink"
                      >
                        <v-img
                          v-if="doc.ext !== 'pdf'"
                          max-height="80"
                          max-width="150"
                          :src="doc.awsLink"
                        ></v-img>
                        <template v-if="doc.ext === 'pdf'">
                          <LoadPDF :pdfFile="doc.awsLink" :pdfName="doc.name" />
                        </template>
                      </v-col>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card>
                      <v-card-title>Select Review Period</v-card-title>
                      <v-divider></v-divider>
                      <v-row class="pl-4">
                        <v-col md="2" xs="3">
                          <v-checkbox
                            label="30 Days"
                            v-model="new30"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>
                        <v-col md="2" xs="3">
                          <v-checkbox
                            label="60 Days"
                            v-model="new60"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>
                        <v-col md="2" xs="3">
                          <v-checkbox
                            label="90 Days"
                            v-model="new90"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>

                        <v-col md="2" xs="3">
                          <v-checkbox
                            label="6 Months"
                            v-model="new6"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>

                        <v-col md="4" xs="3">
                          <v-checkbox
                            label="12 Months"
                            v-model="new12"
                            :readonly="readonly"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                      <v-col cols="12">
                        <v-textarea
                          label="Review Notes"
                          outlined
                          v-model="newReviewNotes"
                          :readonly="readonly"
                        ></v-textarea>
                      </v-col>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card>
                      <v-card-title
                        >Informed consent of the individual. Assurance that
                        interventions and supports will cause no harm to the
                        individual.
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-col class="d-flex" cols="12" sm="12" md="6">
                        <v-checkbox
                          v-model="newClientConsent"
                          label="Client Informed Consent"
                          @click="showSignaturePadClient = true"
                          :disabled="readonly"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" v-if="newClientSignature">
                        <v-img
                          max-height="80"
                          max-width="150"
                          :src="newClientSignature"
                        ></v-img>
                      </v-col>
                      <v-col class="d-flex" cols="12" sm="12" md="6">
                        <v-checkbox
                          v-model="newGuardianConsent"
                          label="Guardian Signature"
                          :disabled="readonly"
                          @click="showSignaturePadGuardian = true"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" v-if="newGuardianSignature">
                        <v-img
                          max-height="80"
                          max-width="150"
                          :src="newGuardianSignature"
                        ></v-img>
                      </v-col>
                      <v-col cols="12">
                        <h3 class="ml-auto mr-auto font-weight-heavy">
                          HRC Signatures
                        </h3>
                      </v-col>

                      <v-col
                        cols="12"
                        v-for="member in HRCMembers"
                        :key="member.ID"
                      >
                        {{ member.Name }}
                        <div v-if="member.ID == userID">
                          <v-btn
                            x-small
                            @click="hrcSignaturePad(member)"
                            v-if="member.Signature == ''"
                            class="ma-1"
                            :readonly="readonly"
                            >Click to Sign
                          </v-btn>
                        </div>

                        <!-- <v-btn x-small @click="removeSignature(member)" class="ma-1" :readonly="readonly">Remove</v-btn> -->

                        <v-col cols="12" v-if="member.Signature">
                          <v-card
                            class="signature-card"
                            style="padding: 10px; width: 150px; height: 120px"
                          >
                            <div
                              class="signature-icons"
                              v-if="member.ID == userID"
                            >
                              <v-chip
                                class="ma-1"
                                color="primary"
                                label
                                text-color="white"
                                small
                                @click="hrcSignaturePad(member)"
                              >
                                <v-icon small> mdi-pencil </v-icon>
                              </v-chip>
                            </div>

                            <div class="signature-image">
                              <v-img
                                max-height="80"
                                max-width="150"
                                :src="member.Signature"
                              ></v-img>
                            </div>
                          </v-card>
                        </v-col>
                      </v-col>
                      <v-dialog v-model="hrcsignaturepad" max-width="500px">
                        <v-card class="signature-card">
                          <v-card-title>
                            <span class="headline">Signature Pad</span>
                            <v-spacer></v-spacer>
                            <v-btn icon @click="hrcsignaturepad = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-card-title>
                          <v-divider></v-divider>
                          <div id="hrcSignaturePad">
                            <VueSignaturePad
                              width="95%"
                              height="300px"
                              ref="hrcSignaturePad"
                              :options="{
                                onBegin: () => {
                                  $refs.hrcSignaturePad.resizeCanvas();
                                },
                              }"
                            />
                          </div>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="hrcSignatureSave"
                              >Save
                            </v-btn>
                            <v-btn @click="hrcSignatureUndo"> Undo </v-btn>
                            <v-btn @click="hrcSignatureClear">Clear </v-btn>
                            <v-btn
                              color="red darken-1"
                              text
                              @click="hrcSignatureCancel"
                              >Cancel
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-card>
                  </v-col>

                  <v-col cols="12">
                    <v-card>
                      <v-card-title
                        >Human Rights Restriction Status
                      </v-card-title>
                      <v-divider></v-divider>
                      <validation-provider
                        v-slot="{ errors }"
                        name="Status"
                        rules="required"
                      >
                        <v-radio-group
                          class="pa-2"
                          v-model="newStatus"
                          :error-messages="errors"
                        >
                          <v-radio label="Active" value="Active"> </v-radio>
                          <v-radio label="Faded" value="Faded"> </v-radio>
                        </v-radio-group>
                      </validation-provider>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </validation-observer>
          </v-card-text>

          <v-card-actions v-if="!directCare">
            <v-spacer></v-spacer>
            <v-btn
              class="white--text"
              color="#259647"
              @click="addRight()"
              v-if="createHumanRights"
              :disabled="isSavingImage || isSavingAnotherImage"
              >Save
            </v-btn>
            <v-btn
              fab
              small
              @click="printItem()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="!createHumanRights && !isAuditorRole"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateRight()"
              v-if="!createHumanRights && !isAuditorRole"
              :disabled="isSavingImage || isSavingAnotherImage"
            >
              Update
            </v-btn>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>

          <v-card-actions v-if="directCare">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close" v-if="directCare">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <div id="printCard" v-show="showPrintCard">

      <h2 style="text-align: center; margin-botton: 10px;"> {{ clientName }}'s Human Rights Restriction</h2>
      <v-row>
        <v-col cols="12" sm="4">  
          <v-text-field
            v-model="newStartDate"
            label="Start Date"
            prepend-icon="mdi-calendar"
            :readonly="readonly"
            clearable
          ></v-text-field>
        </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
                v-model="newReviewDate"
                label="Review Date"
                prepend-icon="mdi-calendar"
                readonly
                clearable
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
                v-model="newDateExpires"
                label="Date Expires"
                prepend-icon="mdi-calendar"
                readonly
                clearable
            ></v-text-field>
          </v-col>

          <v-col cols="12">

              <v-card-title>Restriction</v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle>Specific and individualized assessed need. If applicable, a way for other
                  individuals to circumvent.
              </v-card-subtitle>

              <v-col cols="12">
                  <v-text-field
                      outlined
                      v-model="newRestriction"
                  ></v-text-field>

              </v-col>

              <!-- <v-col cols="12">
                <v-file-input
                  v-model="newDocument"
                  class="pa-2"
                  label="Select documents to upload"
                  show-size
                  filled
                  multiple
                  prepend-icon="mdi-camera"
                  accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  @change="fileSelected"

                >
                  <template #selection="{ text, index }">
                    <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                  </template>
                </v-file-input>
              </v-col> -->

              <v-col cols="12" sm="12" md="3"
                    v-for="doc in newDocument"
                    :key="doc.awsLink"
              >
                  <!-- <v-img
                    max-height="80"
                    max-width="150"
                    :src="doc.awsLink"
                  ></v-img> -->
                  <img :src="doc.awsLink" width="150" height="75">
                  <template v-if="doc.ext == 'pdf'">
                      <LoadPDF
                          :pdfFile="doc.awsLink"
                          :pdfName="doc.name"
                      />
                  </template>
              </v-col>
              <v-card-actions>
                  <v-btn class="ma-2" small>View Supporting Documentation</v-btn>
              </v-card-actions>

          </v-col>

          <v-col cols="12">

              <v-card-title>Justification</v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>A clear description of the condition that is directly proportionate to the specific
                  assessed need.
              </v-card-subtitle>
              <v-col cols="12">
                  <!-- <v-textarea
                    label="Enter Justification"
                    outlined
                    v-model="newJustification"
                  ></v-textarea> -->
                  <span>Justification</span>
                  <div>{{ newJustification }}</div>
              </v-col>

          </v-col>


          <v-col cols="12">

              <v-card-title>Previous Interventions</v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>Less Intrusive methods used that did not work. Previous positive interventions and
                  supports tried.
              </v-card-subtitle>
              <v-col cols="12">
                  <!-- <v-textarea
                    label="Enter Interventions"
                    outlined
                    v-model="newIntervention"
                  ></v-textarea> -->
                  <span>Interventions</span>
                  <div>{{ newIntervention }}</div>

              </v-col>

              <v-col cols="12" sm="12" md="3"
                    v-for="doc in newDocument2"
                    :key="doc.awsLink"
              >
                  <!-- <v-img
                    max-height="80"
                    max-width="150"
                    :src="doc.awsLink"
                  ></v-img> -->
                  <img :src="doc.awsLink" width="150" height="75">
                  <template v-if="doc.ext == 'pdf'">
                      <LoadPDF
                          :pdfFile="doc.awsLink"
                          :pdfName="doc.name"
                      />
                  </template>
              </v-col>


              <!-- <v-card-actions>
                  <v-btn small>View Previous Interventions</v-btn>

              </v-card-actions> -->

              <v-col cols="12">
                  <!-- <v-textarea
                    label="Previous Interventions"
                    outlined
                    v-model="previousIntervention"
                  ></v-textarea> -->
                  <span>Previous Intervention</span>
                  <div>{{ previousIntervention }}</div>

              </v-col>

          </v-col>

          <v-col cols="12">

              <v-card-title>Data Collection</v-card-title>
              <v-divider></v-divider>
              <v-card-subtitle>Regular collection and review of data of measure effectiveness.</v-card-subtitle>
              <v-card-actions>
                  <v-btn
                      class="ma-2"
                      small
                      @click="goToReport()"

                  >View Data Collection
                  </v-btn>

              </v-card-actions>

          </v-col>


          <v-col cols="12">

              <v-card-title>Review</v-card-title>
              <v-divider></v-divider>

              <v-card-subtitle>Establish time limits for period reviews to determine if it is still necessary or
                  can be terminated.
              </v-card-subtitle>
              <v-col cols="12">
                  <!-- <v-textarea
                    label="Enter Review Details Include Restoration and Fade Plan"
                    outlined
                    v-model="newReview"
                  ></v-textarea> -->
                  <span>Review Details Include Restoration and Fade plan</span>
                  <div>{{ newReview }}</div>
              </v-col>

          </v-col>

          <v-col cols="12">

              <v-card-title>Select Review Period</v-card-title>
              <v-divider></v-divider>
              <v-row class="pl-4">
                  <v-col md="2" xs="3">
                      <v-checkbox
                          label="30 Days"
                          v-model="new30"
                      ></v-checkbox>
                  </v-col>
                  <v-col md="2" xs="3">
                      <v-checkbox
                          label="60 Days"
                          v-model="new60"
                      ></v-checkbox>
                  </v-col>
                  <v-col md="2" xs="3">
                      <v-checkbox
                          label="90 Days"
                          v-model="new90"
                      ></v-checkbox>
                  </v-col>

                  <v-col md="2" xs="3">
                      <v-checkbox
                          label="6 Months"
                          v-model="new6"
                      ></v-checkbox>
                  </v-col>

                  <v-col md="4" xs="3">
                      <v-checkbox
                          label="12 Months"
                          v-model='new12'
                      ></v-checkbox>
                  </v-col>
              </v-row>

              <v-col cols="12">
                  <!-- <v-textarea
                    label="Review Notes"
                    outlined
                    v-model="newReviewNotes"
                  ></v-textarea> -->
                  <span>Review Notes</span>
                  <div>{{ newReviewNotes }}</div>
              </v-col>


          </v-col>

          <div class="pageBreak"></div>


          <v-col cols="12">

              <v-card-title>Informed to consent of the individual. Assurance that interventions and supports will
                  cause no harm to the individual.
              </v-card-title>
              <v-divider></v-divider>
              <v-col class="d-flex" cols="12" sm="12" md="6">
                  <v-checkbox
                      v-model="newClientConsent"
                      label="Client Informed Consent"
                      @click="showSignaturePadClient = true"
                      :disabled="readonly"
                  ></v-checkbox>
              </v-col>
              <v-col cols="12">
                  <img :src="newClientSignature" width="150" height="75">
              </v-col>
              <v-col class="d-flex" cols="12" sm="12" md="6">
                  <v-checkbox
                      v-model="newGuardianConsent"
                      label="Guardian Signature"
                      @click="showSignaturePadGuardian = true"
                      :disabled="readonly"
                  ></v-checkbox>
              </v-col>
              <v-col cols="12">
                  <!-- <v-img
                    max-height="80"
                    max-width="150"
                    :src="newGuardianSignature"
                  ></v-img> -->
                  <img :src="newGuardianSignature" width="150" height="75">
              </v-col>
              <!-- <v-col cols="12">
                <v-select
                  label="Select HRC Members"
                  :items="committee"
                  item-text="Name"
                  item-value="_id"
                  multiple
                  v-model="HRCCommittee"
                  @change="updateSignatureList(HRCCommittee)"
                  return-object
                ></v-select>
              </v-col> -->
              <v-col cols="12">
                  <h3 class="ml-auto mr-auto font-weight-heavy">HRC Signatures</h3>
              </v-col>

              <v-col cols="12"
                    v-for="member in HRCMembers"
                    :key="member.Name"
              >
                  {{ member.Name }}
                  <!-- <v-btn x-small @click="hrcSignaturePad(member)" v-if="member.Signature == ''" class="ma-1">Click to Sign</v-btn>
                  <v-btn x-small @click="removeSignature(member)" class="ma-1">Remove</v-btn> -->

                  <v-col cols="12" id="section-to-print">
                      <!-- <v-img
                        max-height="80"
                        max-width="150"
                        :src="member.Signature"
                      ></v-img> -->
                      <img :src='member.Signature' width="150" height="75"/>

                  </v-col>
              </v-col>


          </v-col>

          <v-col cols="12">

              <v-card-title>Human Rights Restriction Status</v-card-title>
              <v-divider></v-divider>
              <v-radio-group
                  class="pa-2"
                  v-model="newStatus"
              >
                  <v-radio
                      label="Active"
                      value="Active"
                  >
                  </v-radio>
                  <v-radio
                      label="Faded"
                      value="Faded"
                  >
                  </v-radio>
              </v-radio-group>

          </v-col>

          <!-- <v-col cols="12">
            Completed Signatures

              <v-card-title
                v-for="sig in AllSignatures"
                :key="sig.ID"
              >{{sig.Name}}

              <v-img
                  max-height="80"
                  max-width="150"
                  :src="sig.Signature"
              ></v-img>
              </v-card-title>

          </v-col> -->

      </v-row>
      </div>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import SignaturePad from "@/components/SignaturePad";
import ClientNav from "@/components/ClientNav";
import Foot from "@/components/Footer";
import moment from "moment";
import renameFileHelper from "@/mixins/renameFileHelper";
import LoadPDF from "@/components/LoadPDF.vue";
import { mapActions } from "vuex";
import momentTz from "moment-timezone";
import reports from "@/mixins/reports";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import {
  displaySuccess,
  displayError,
  displayInfo,
} from "@/service/notification-message.service";
import socket from "@/socket";

const url = require("../../../client_config/config").url;

export default {
  mixins: [renameFileHelper, reports],
  components: {
    ClientNav,
    Foot,
    LoadPDF,
    SignaturePad,
    ValidationObserver,
    ValidationProvider,
  },
  data: function () {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      dialog: false,
      editRight: false,
      newRight: false,
      msg: false,
      text: "",
      rights: [],
      humanRights: {},
      clientID: this.$route.params.clientID,
      rightId: this.$route.params.id,
      userID: localStorage.getItem("userID"),
      tempData: [],
      tempData2: [],
      titleForm: "New Human Rights Restriction",
      newStartDate: "",
      newReviewDate: "",
      newDateExpires: "",
      newDateNotified: "",
      newPreparedBy: "",
      newRestriction: "",
      newJustification: "",
      newIntervention: "",
      previousIntervention: "",
      newReview: "",
      newReviewNotes: "",
      new30: false,
      new60: false,
      new90: false,
      new6: false,
      new12: false,
      newClientConsent: false,
      newClientSignature: "",
      newGuardianConsent: false,
      newGuardianSignature: "",
      newHRCConsent: false,
      newHRCSignature: "",
      newChairperson: "",
      newNameTitle: "",
      AllSignatures: [],
      editedIndex: -1,
      isLoading: true,
      clientsignaturepad: false,
      guardiansignaturepad: false,
      guardiansignaturepadpop: false,
      hrcsignaturepad: false,
      committee: [],
      HRCCommittee: "",
      HRCMembers: [],
      HRCCompletedSignatures: [],
      memberID: "",
      memberName: "",
      memberSignature: "",
      newDocument: [],
      newDocument2: [],
      reviewDocument: [],
      uploadFile: "",
      uploadFile2: "",
      reviewDocumentFile: "",
      staff: localStorage.getItem("Name"),
      newSignature: "",
      directCare: false,
      readonly: false,
      newStatus: "",
      showSignaturePadClient: false,
      showSignaturePadGuardian: false,
      totalServerItems: 0,
      itemsPerPage: 10,
      page: 1,
      timezone: momentTz.tz.guess(),
      createHumanRights: false,
      isSavingImage: false,
      isSavingAnotherImage: false,
      newlySignedHRCMembers: [],
      showPrintCard: false,
    };
  },

  computed: {
    clientName() {
      if (this.$store.state.clients.client) {
        return this.$store.state.clients.client.Name;
      }
      return "";
    },
    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  watch: {},

  async created() {
    this.createHumanRights = this.$route.query.createHumanRights === "true";
    await this.getCommittee();
    this.getClientInfo(this.clientID);
    if (
      localStorage.getItem("userRole") === "Direct Care Staff" ||
      localStorage.getItem("userRole") === "Shift Lead" ||
      localStorage.getItem("userRole") === "Assistant Manager" ||
      localStorage.getItem("userRole") === "House Manager" ||
      localStorage.getItem("userRole") === "Program Manager"
    ) {
      this.directCare = true;
      this.readonly = true;
    }
    
    socket.connect();
    socket.on("reload-signed-hrc-member", (rightId, memberId, memberName) => {
      if (this.rightId == rightId && this.memberId != memberId) {
        displayInfo(`${memberName} signed.`);
        this.reloadHRCMembers();
      }
    });
  },

  mounted() {
    if (!this.createHumanRights) {
      this.getHumanRightRestriction();
    }
  },

  methods: {
    ...mapActions({
      getClientInfo: "clients/getClient",
    }),

    initialize() {
      this.rights = [];
    },

    async viewRight(item) {

      if (!this.HRCMembers || this.HRCMembers.length === 0) {
        await this.getCommittee();
      }

      this.titleForm = "Viewing Human Right";
      this.newStartDate = moment(item.StartDate).format("YYYY-MM-DD");
      this.newReviewDate = moment(item.ReviewDate).format("YYYY-MM-DD");
      this.newDateExpires = moment(item.DateExpires).format("YYYY-MM-DD");
      this.newDateNotified = moment(item.DateNotified).format("YYYY-MM-DD");
      this.newRestriction = item.Restriction;
      this.newJustification = item.Justification;
      this.newIntervention = item.Intervention;
      this.previousIntervention = item.PreviousIntervention;
      this.newReview = item.Review;
      this.newReviewNotes = item.ReviewNotes;
      this.new30 = item.Days30;
      this.new60 = item.Days60;
      this.new90 = item.Days90;
      this.new6 = item.Months6;
      this.new12 = item.Months12;
      this.newClientConsent = item.ClientConsent; 
      this.newClientSignature = item.ClientSignature;
      this.newGuardianConsent = item.GuardianConsent;
      this.newGuardianSignature = item.GuardianSignature;
      this.newChairperson = item.Chairperson;
      this.newGuardianDate = item.GuardianDate;
      this.newAllSignatures = item.AllSignatures;
      this.newStatus = item.Status;

      //merge HRC member to HRC item
      this.HRCMembers = this.mergeHRCMembers(item.HRCMembers)

      if (item.documents?.length > 0) {
        const tempData = [];
        const tempData2 = [];
        const reviewDocumentData = [];

        for (let i = 0; i < item.documents.length; i++) {
          let doc = item.documents[i];
          let fileExt = item.documents[i].AWSLink.split(".").pop();

          const documentData = {
            awsLink: doc.AWSLink,
            name: doc.Name,
            ext: fileExt,
            id: doc._id,
          };

          if (doc.Category === "Human Rights Restriction") {
            tempData.push(documentData);
          } else if (doc.Category === "Human Rights Intervention") {
            tempData2.push(documentData);
          } else {
            reviewDocumentData.push(documentData);
          }
        }
        this.newDocument = tempData;
        this.newDocument2 = tempData2;
        this.reviewDocument = reviewDocumentData;
      }
    },

    close() {
      this.$router.go(-1);
      this.clearData();
    },

    async updateRight() {
      let req_body = {
        StartDate: this.newStartDate,
        ReviewDate: this.newReviewDate,
        DateExpires: this.newDateExpires,
        DateNotified: this.newDateNotified,
        PreparedBy: this.newPreparedBy,
        Restriction: this.newRestriction,
        Justification: this.newJustification,
        Intervention: this.newIntervention,
        PreviousIntervention: this.previousIntervention,
        Review: this.newReview,
        ReviewNotes: this.newReviewNotes,
        Days30: this.new30,
        Days60: this.new60,
        Days90: this.new90,
        Months6: this.new6,
        Months12: this.new12,
        ClientConsent: this.newClientConsent,
        ClientSignature: this.newClientSignature,
        GuardianConsent: this.newGuardianConsent,
        GuardianSignature: this.newGuardianSignature,
        Chairperson: this.newChairperson,
        HRCMembers: this.HRCMembers,
        AllSignatures: this.HRCCompletedSignatures,
        Status: this.newStatus,
      };

      try {
        const response = await axios.put(
          `${url}/rights/${this.rightId}`,
          req_body
        );        

        if (this.newlySignedHRCMembers.length > 0) {
          for ( var i = 0; i < this.newlySignedHRCMembers.length; i++) {
            socket.emit('newly-signed-hrc-member', this.rightId, this.newlySignedHRCMembers[i].ID, this.newlySignedHRCMembers[i].Name);
          }
        }

        if (response.status !== 200) {
          displayError(
            "An error occurred on updating human rights restriction. Please try again."
          );
          return;
        }

        if (this.uploadFile !== null && this.uploadFile !== undefined) {
          this.isSavingImage = true;
          displayInfo("Uploading file(s)...Please wait");
          await this.saveFile();
          this.isSavingImage = false;
        }

        if (this.uploadFile2 !== null && this.uploadFile2 !== undefined) {
          this.isSavingAnotherImage = true;
          displayInfo("Uploading file(s)...Please wait");
          await this.saveFile2();
          this.isSavingAnotherImage = false;
        }

        if (
          this.reviewDocumentFile !== null &&
          this.reviewDocumentFile !== undefined
        ) {
          this.isSavingAnotherImage = true;
          displayInfo("Uploading file(s)...Please wait");
          await this.saveReviewFile();
          this.isSavingAnotherImage = false;
        }

        displaySuccess("Human rights restriction updated successfully.");
        this.getRights();
      } catch (error) {
        console.log(error);
      } finally {
        this.close();
      }
    },

    getRights(item = { page: 1, itemsPerPage: 10 }) {
      this.isLoading = true;

      const query = {
        page: item.page,
        limit: item.itemsPerPage,
        search: this.search,
        tz: this.timezone,
      };

      axios
        .get(`${url}/rights/client/${this.clientID}`, { params: query })
        .then((res) => {
          this.rights = [];
          this.rights = res.data.rights.docs;
          this.totalServerItems = res.data.rights.totalDocs;
        })
        .finally(() => (this.isLoading = false));
    },

    getHumanRightRestriction() {
      axios
        .get(`${url}/rights/specific/${this.rightId}`)
        .then((res) => {
          this.humanRights = res.data.right;
          this.viewRight(this.humanRights);
        })
        .finally(() => (this.isLoading = false));
    },

    async getCommittee() {
      await axios.get(`${url}/users/committee`).then((res) => {
        this.committee = res.data.users;
        this.HRCMembers = [];
        for (var i = 0; i < this.committee.length; i++) {
          var newSignature = {
            ID: this.committee[i]._id,
            Date: "",
            Name: this.committee[i].Name,
            Signature: "",
          };
          this.HRCMembers.push(newSignature);
        }
      });
    },

    async addRight() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        let req_body = {
          StartDate: this.newStartDate,
          ReviewDate: this.newReviewDate,
          DateExpires: this.newDateExpires,
          PreparedBy: this.newPreparedBy,
          DateNotified: this.newDateNotified,
          Restriction: this.newRestriction,
          Justification: this.newJustification,
          Intervention: this.newIntervention,
          PreviousIntervention: this.previousIntervention,
          Review: this.newReview,
          ReviewNotes: this.newReviewNotes,
          Days30: this.new30,
          Days60: this.new60,
          Days90: this.new90,
          Months6: this.new6,
          Months12: this.new12,
          ClientConsent: this.newClientConsent,
          ClientSignature: this.newClientSignature,
          GuardianConsent: this.newGuardianConsent,
          GuardianSignature: this.newGuardianSignature,
          HRCMembers: this.HRCMembers,
          AllSignatures: this.HRCCompletedSignatures,
          Document: this.Document,
          Status: this.newStatus,
          Document2: this.Document2,
          ClientID: this.clientID,
        };

        try {
          const response = await axios.post(`${url}/rights`, req_body);

          this.rightId = response.data.data._id;

          if (response.status !== 201) {
            displayError(
              "An error occurred on adding human rights restriction. Please try again."
            );
            return;
          }

          displaySuccess("Human rights restriction added successfully.");
          this.getRights();

          if (this.uploadFile !== null && this.uploadFile !== undefined) {
            this.isSavingImage = true;
            displayInfo("Uploading file(s)...Please wait");
            await this.saveFile();
            this.isSavingImage = false;
          }

          if (this.uploadFile2 !== null && this.uploadFile2 !== undefined) {
            this.isSavingAnotherImage = true;
            displayInfo("Uploading file(s)...Please wait");
            await this.saveFile2();
            this.isSavingAnotherImage = false;
          }

          if (
            this.reviewDocumentFile !== null &&
            this.reviewDocumentFile !== undefined
          ) {
            this.isSavingAnotherImage = true;
            displayInfo("Uploading file(s)...Please wait");
            await this.saveReviewFile();
            this.isSavingAnotherImage = false;
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.close();
        }
      }
    },

    clearData() {
      this.newStartDate = "";
      this.newReviewDate = "";
      this.newDateExpires = "";
      this.newPreparedBy = "";
      this.newDateNotified = "";
      this.newRestriction = "";
      this.newJustification = "";
      this.newIntervention = "";
      this.previousIntervention = "";
      this.newReview = "";
      this.newReviewNotes = "";
      this.new30 = false;
      this.new60 = false;
      this.new90 = false;
      this.new6 = false;
      this.new12 = false;
      this.newClientConsent = false;
      this.newGuardianSignature = "";
      this.newGuardianConsent = false;
      this.newChairperson = "";
      this.newNameTitle = "";
      this.newAllSignatures = "";
      this.newClientSignature = "";
      this.newHRCSignature = "";
      this.HRCCommittee = [];
      this.HRCCompletedSignatures = [];
      //this.HRCMembers = [];
      this.newDocument = [];
      this.newDocument2 = [];
      this.reviewDocumentFile = [];
      this.newStatus = false;
      this.$refs.observer.reset();
      this.getCommittee();
    },

    signatureDataClient(data) {
      this.newClientSignature = data;
    },

    signatureDataGuardian(data) {
      this.newGuardianSignature = data;
    },

    hrcSignaturePad(member) {
      this.hrcsignaturepad = true;
      this.memberID = member.ID;
    },

    hrcSignatureUndo() {
      this.$refs.hrcSignaturePad.undoSignature();
    },

    hrcSignatureClear() {
      this.$refs.hrcSignaturePad.clearSignature();
    },

    hrcSignatureCancel() {
      this.hrcsignaturepad = false;
    },

    hrcSignatureSave() {
      const { isEmpty, data } = this.$refs.hrcSignaturePad.saveSignature();
      if (!isEmpty) {
        for (var i = 0; i < this.HRCMembers.length; i++) {
          if (this.memberID == this.HRCMembers[i].ID) {
            this.HRCMembers[i] = {
              ID: this.HRCMembers[i].ID,
              Date: this.HRCMembers[i].Date,
              Name: this.HRCMembers[i].Name,
              Signature: data,
            };
            this.newlySignedHRCMembers.push(this.HRCMembers[i]);
          }          
        }
      }

      this.hrcsignaturepad = false;
    },

    updateSignatureList(HRCCommittee) {
      var newList = [];
      newList.push(HRCCommittee[0].Name);
      var newSignature = {
        ID: HRCCommittee[0]._id,
        Date: "",
        Name: newList[0],
        Signature: "",
      };
      this.HRCMembers.push(newSignature);
      this.HRCCommittee = [];
    },

    removeSignature(member) {
      let index = this.HRCMembers.indexOf(member);
      this.HRCMembers.splice(index, 1);
    },

    goToReport() {
      this.$router.push(`/HRCReport/${this.clientID}/${this.rightId}`);
    },

    async fileSelected(e) {
        this.uploadFile = await this.renameFileHelper(e, this.clientName, "HumanRights");
    },

    async fileSelected2(e) {
        this.uploadFile2 = await this.renameFileHelper(e, this.clientName, "HumanRights");
    },

    async selectedReviewFile(e) {
        this.reviewDocumentFile = await this.renameFileHelper(e, this.clientName, "HumanRights");
    },

    async saveFile() {
        this.message = "";
        await this.uploadFiles(this.uploadFile, "fileuploader");
    },

    async saveFile2() {
        this.message = "";
        await this.uploadFiles(this.uploadFile2, "fileuploader2");
    },

    async saveReviewFile() {
        this.message = "";
        await this.uploadFiles(this.reviewDocumentFile, "fileuploader3");
    },

    async uploadFiles(files, endpoint) {
        for (const file of files) {
            await this.uploadDocumentFile(file, endpoint);
        }
    },

    async uploadDocumentFile(file, endpoint) {
        const formData = new FormData();
        formData.append("humanRights", file);
        const ct = { headers: { "content-type": "multipart/form-data" } };

        try {
            const res = await axios.post(`${url}/rights/${endpoint}/${this.rightId}/${this.clientID}`, formData, ct);
            if (res) {
                this.getRights();
            }
        } catch (err) {
            console.log(err);
        }
    },

    deleteChip(index) {
        this.newDocument.splice(index, 1);
    },

    deleteChip2(index) {
        this.newDocument2.splice(index, 1);
    },

    deleteReviewDocument(index) {
        this.reviewDocument.splice(index, 1);
    },

    reloadHRCMembers() {
      axios
        .get(`${url}/rights/specific/${this.rightId}`)
        .then((res) => {
          this.HRCMembers = res.data.right?.HRCMembers;
        })
        .finally(() => (this.isLoading = false));

    },
    printItem() {
      // Show the printCard content
      this.showPrintCard = true;

      // Wait for the DOM to update and then trigger the print dialog
      this.$nextTick(() => {
        window.print();

        // Hide the printCard content after printing
        this.showPrintCard = false;
      });
    },

    mergeHRCMembers(savedMembers) {
      const mergedMembers = this.HRCMembers.reduce((acc, member) => {
        const existingMember = acc.find((m) => m.ID === member.ID);
        if (!existingMember) {
          acc.push(member);
        }
        
        return acc;
      }, savedMembers);

      return mergedMembers;
    },
  },
};
</script>
<style>
@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

#printTable {
  display: none;
}

#printItem {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #printTable {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  #printItem {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }
  #printCard {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  .hideOnPrint {
    display: none;
    border: none;
  }

  .pageBreak {
    clear: both;
    page-break-before: always;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }

  body {
    margin: 1.6cm;
  }
}

#hrcSignaturePad {
  cursor: crosshair;
}

.signature-card .v-card__actions button {
  flex: 1 0 auto !important;
}

canvas {
  display: block;
  margin: auto;
}

#hrcSignaturePad > div {
  box-shadow: rgb(0 0 0 / 25%) 0px 54px 55px, rgb(0 0 0 / 12%) 0px -12px 30px,
    rgb(0 0 0 / 12%) 0px 4px 6px, rgb(0 0 0 / 17%) 0px 12px 13px,
    rgb(0 0 0 / 9%) 0px -3px 5px;
  margin: 15px auto;
  border-radius: 5px;
  border: none;
}

.signature-card {
  width: 700px;
}

@media only screen and (max-width: 768px) {
  .signature-card {
    width: 100%;
  }

  .btn-supporting-doc {
    width: 90%;
    font-size: 0.68rem !important;
  }
}

.signature-card {
  position: relative;
}

.signature-icons {
  position: absolute !important;
  bottom: 0;
  right: 0;
}

.signature-image {
  position: absolute !important;
  bottom: 0;
  right: 0;
  margin-bottom: 10%;
}
</style>
